import React from "react";
import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const AcademicData: React.FC = () => {
  const { formData, updateFormData } = useOutletContext<FormContext>();

  return (
    <FormProvider {...formData}>
      <FormSection title={t("security-clearance.academic-qualifications")}>
        <div className="md:col-span-full">
          <FormItem<PortSecurityFormData, "academicQualification">
            name="academicQualification"
            type="text"
            maxChars={200}
            label={t("security-clearance.academic-qualification")}
            testId="security-academicQualification"
            onFieldChange={updateFormData}
          />
        </div>
        <FormItem<PortSecurityFormData, "placeOfStudy">
          name="placeOfStudy"
          type="text"
          maxChars={200}
          label={t("security-clearance.place-of-study")}
          testId="security-placeOfStudy"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "university">
          name="university"
          type="text"
          maxChars={200}
          label={t("security-clearance.university")}
          testId="security-university"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "languagesKnown">
          name="languagesKnown"
          type="text"
          maxChars={200}
          label={t("security-clearance.languages-known")}
          testId="security-languagesKnown"
          onFieldChange={updateFormData}
        />
        <FormItem<PortSecurityFormData, "certificateDate">
          name="certificateDate"
          type="date-picker"
          label={t("security-clearance.certificate-date")}
          testId="security-certificateDate"
          onFieldChange={updateFormData}
          timePicker={false}
          dateConstraint="past"
        />
      </FormSection>
    </FormProvider>
  );
};

export default AcademicData;
